export default __webpack_public_path__ + "static/media/lipstick10.676bd1d4.jpg";